import React, { FC } from 'react';
import { Modal } from 'antd';
import MiniPTGIF from 'url:src/assets/videos/mini-pt-care.mp4';
import './UnpublishPackageModal.scss';

interface UnpublishPackageModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export const UnpublishPackageModal: FC<UnpublishPackageModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  isPending = false,
}) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={onCancel}
      centered
      width={460}
      closeIcon={null}
      rootClassName="unpublish-package-modal"
      className="unpublish-package-modal"
      styles={{
        mask: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(6, 7, 35, 0.8)',
        },
        container: {
          background: 'linear-gradient(180deg, #101438 0%, #070924 100%)',
          backgroundColor: '#0c0f2b',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          borderRadius: '20px',
          boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
          padding: '36px 32px 32px',
          color: '#ffffff',
          overflow: 'hidden',
        },
        body: {
          padding: 0,
          background: 'transparent',
        },
      }}
    >
      <div className="unpublish-modal-content">
        {/* Fire Orb Video Badge */}
        <div className="unpublish-icon-wrapper">
          <video src={MiniPTGIF} autoPlay loop muted playsInline className="unpublish-video-orb" />
          <span className="minipt-inner-text">{'miniPT'}</span>
        </div>

        <h3 className="unpublish-modal-title">
          {
            'Are you sure you want to unpublish your package? Clients won’t be able to buy your services anymore.'
          }
        </h3>

        <div className="unpublish-modal-actions">
          <button
            type="button"
            className="btn-go-back-outline"
            onClick={onCancel}
            disabled={isPending}
          >
            <svg
              className="arrow-left-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6667 8H3.33334M3.33334 8L8.00001 12.6667M3.33334 8L8.00001 3.33334"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{'No, Go Back to Edit'}</span>
          </button>

          <button
            type="button"
            className="btn-confirm-unpublish-white"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Unpublishing...' : 'Yes, Unpublish'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
